export default __webpack_public_path__ + "static/media/play_video.b3468490.svg";